import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            luluca 的核心特色
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            六大核心功能，覆盖从灵感到发布的全流程，让创作变得前所未有的简单和高效
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="group bg-background-50 border border-background-200 rounded-2xl p-6 md:p-7 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}